import type {ResourceChangeRealtimeHandler} from "../../../shared/realtime/resource-change-realtime.types";
import type {output} from "zod";

import {ServiceRealtimeChange} from "@project/sdk/realtime";

import {serviceKeys} from "../service-keys";

type ServiceRealtimeChangeEvent = output<typeof ServiceRealtimeChange>;

export const servicesRealtimeHandler: ResourceChangeRealtimeHandler<ServiceRealtimeChangeEvent> = {
  resource: "engineering.services",
  queryKey: serviceKeys.all,
  eventSchema: ServiceRealtimeChange,
  async handleEvent(event, queryClient) {
    if (event.change === "CREATED") {
      await queryClient.invalidateQueries({queryKey: serviceKeys.lists()});
      return;
    }
    await queryClient.invalidateQueries({queryKey: serviceKeys.all});
  },
};
